import BaseReducer from "../../utilities/BaseReducer";
import IAction from "../../models/IAction";
import IMenuState from "./models/MenuStore";
import MenuAction from "./MenuAction";
import MenuModel from "./models/MenuModel";

export default class MenuReducer extends BaseReducer<IMenuState> {
    public readonly initialState: IMenuState = {
        menuItems: [],
        sitePaths: [],
    };

    public [MenuAction.REQUEST_MENUS_FINISHED](state: IMenuState, action: IAction<MenuModel[]>): IMenuState {
        return {
            ...state,
            menuItems: action.payload!,
        };
    }

    public [MenuAction.REQUEST_PATHS_FINISHED](state: IMenuState, action: IAction<MenuModel[]>): IMenuState {
        return {
            ...state,
            sitePaths: action.payload!,
        };
    }
}
